const Footer = () => null;
export default Footer;
